/**
 * Datas que a API devolve como dia civil, sem hora nem fuso.
 *
 * Campos mapeados com @Temporal(TemporalType.DATE) no wcond (vencimento,
 * referência, liquidação...) chegam no JSON como "2026-09-10". O construtor
 * `new Date(s)` trata esse formato como meia-noite **UTC**; ao formatar em
 * America/Sao_Paulo (UTC-3) o relógio volta para 21h do dia anterior e a tela
 * mostra 09/09 no lugar de 10/09. Um boleto com vencimento no dia 10 aparecia
 * vencendo no dia 9 para o morador.
 *
 * Aqui a data é montada com os componentes locais, então o dia exibido é
 * exatamente o dia que veio da API, em qualquer fuso.
 */
const DATA_SIMPLES = /^(\d{4})-(\d{2})-(\d{2})$/

export function parseDataApi(valor) {
  if (valor === null || valor === undefined || valor === '') return null
  if (valor instanceof Date) return valor

  const m = DATA_SIMPLES.exec(String(valor).trim())
  if (m) {
    const [, ano, mes, dia] = m
    return new Date(Number(ano), Number(mes) - 1, Number(dia))
  }

  // Com hora e/ou fuso ("2026-09-10T15:30:00-03:00") o instante é bem definido.
  return new Date(valor)
}

export function formatarDataApi(valor) {
  const data = parseDataApi(valor)
  if (!data || Number.isNaN(data.getTime())) return ''
  return data.toLocaleString('pt-br', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}

export default { parseDataApi, formatarDataApi }
